<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 24.0001C15.7 23.9996 17.9984 23.2073 19.8627 21.7494L25.724 27.6107L27.6093 25.7254L21.748 19.8641C23.2067 17.9996 23.9994 15.7007 24 13.3334C24 7.45208 19.2147 2.66675 13.3333 2.66675C7.45199 2.66675 2.66666 7.45208 2.66666 13.3334C2.66666 19.2147 7.45199 24.0001 13.3333 24.0001ZM13.3333 5.33341C17.7453 5.33341 21.3333 8.92141 21.3333 13.3334C21.3333 17.7454 17.7453 21.3334 13.3333 21.3334C8.92132 21.3334 5.33332 17.7454 5.33332 13.3334C5.33332 8.92141 8.92132 5.33341 13.3333 5.33341Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'SearchIcon',

  props: {
    fill: {
      type: String,
      default: '#ffffff',
    },
  },
}
</script>
